import { Content, Layout } from '@/shared/components/ui/layout'

import ApprovalPageFooter from './ApprovalPageFooter'
import ApprovalPageHeader from './ApprovalPageHeader'
import { ApprovalPageProvider } from './ApprovalPageProvider'
import ApprovalTable from './ApprovalTable/ApprovalTable'
import ApprovalTableHeader from './ApprovalTable/ApprovalTableHeader'

export function ApprovalPage() {
	return (
		<ApprovalPageProvider>
			<Layout>
				<ApprovalPageHeader />
				<Layout className='relative flex size-full flex-col overflow-hidden px-4'>
					<ApprovalTableHeader />
					<Content className='border-base h-full overflow-hidden rounded-lg border border-solid'>
						<ApprovalTable />
					</Content>
					<ApprovalPageFooter />
				</Layout>
			</Layout>
		</ApprovalPageProvider>
	)
}
